{
  "removeButtonLabel": "Poista",
  "removeDescription": "Poista tunniste painamalla Poista-painiketta."
}
